import React, { useEffect, useState } from 'react';
import './ZoomAnimation.css';

interface ZoomAnimationProps {
  startX: number;
  startY: number;
  endX: number;
  endY: number;
  endWidth: number;
  endHeight: number;
  onComplete: () => void;
}

const ZoomAnimation: React.FC<ZoomAnimationProps> = ({
  startX,
  startY,
  endX,
  endY,
  endWidth,
  endHeight,
  onComplete
}) => {
  const [currentStep, setCurrentStep] = useState(0);
  const totalSteps = 6;
  const stepDuration = 40; // ms per step

  useEffect(() => {
    if (currentStep < totalSteps) {
      const timer = setTimeout(() => {
        setCurrentStep(currentStep + 1);
      }, stepDuration);
      
      return () => clearTimeout(timer);
    } else {
      // Animation complete
      const completeTimer = setTimeout(() => {
        onComplete();
      }, stepDuration);
      
      return () => clearTimeout(completeTimer);
    }
  }, [currentStep, onComplete]);

  const calculateStep = (step: number) => {
    const progress = step / (totalSteps - 1);
    
    // Start with small rectangle (icon size)
    const startWidth = 60;
    const startHeight = 60;
    
    // Interpolate position and size
    const x = startX + (endX - startX) * progress;
    const y = startY + (endY - startY) * progress;
    const width = startWidth + (endWidth - startWidth) * progress;
    const height = startHeight + (endHeight - startHeight) * progress;
    
    return { x, y, width, height };
  };

  return (
    <div className="zoom-animation-container">
      {Array.from({ length: totalSteps }, (_, index) => {
        if (index > currentStep) return null;
        
        const { x, y, width, height } = calculateStep(index);
        const opacity = index === currentStep ? 1 : 0.3 - (currentStep - index) * 0.1;
        
        return (
          <div
            key={index}
            className="zoom-rectangle"
            style={{
              left: x - width / 2,
              top: y - height / 2,
              width,
              height,
              opacity: Math.max(0, opacity)
            }}
          />
        );
      })}
    </div>
  );
};

export default ZoomAnimation;